import "./App.css";
import { useState } from "react";
import { isMobile } from "react-device-detect";
import { MapContainer, GeoJSON, ZoomControl } from "react-leaflet";
import Chart from "./components/Chart";
import dataJson from "./data/msk_with_data_v5.json";
import logo from "./images/Proekt.svg";
const qs = require("qs");

const data = {};
data.features = dataJson.features.sort((a, b) =>
  a.properties.visible_name.localeCompare(b.properties.visible_name)
);
const categories = {
  crime: { name: "Всего преступлений", name_short: "всего" },
  street: { name: "На улице", name_short: "на улице" },
  murder: { name: "Убийства", name_short: "убийства" },
  harm: { name: "Тяжкий вред здоровью", name_short: "тяжкий вред" },
  theft: { name: "Кражи", name_short: "кражи" },
  openly: { name: "Грабежи", name_short: "грабежи" },
  robbery: { name: "Разбой", name_short: "разбой" },
  cameras: { name: "Видеокамеры", name_short: "видеокамеры" },
};

const colors = ["#FFCBCC", "#FF9EA0", "#FF7174", "#FF4448", "#FE0005"];
const years = ["2016", "2017", "2018", "2019", "2020"];
const yearsData = data.features.reduce((acc, el) => {
  years.forEach((y) => {
    const sum = parseInt(el.properties["crime_" + y]);
    acc[y] = acc[y] + sum > 0 ? sum : 0;
  });
  return acc;
}, {});

const { id: fid } = qs.parse(window.location.search, {
  ignoreQueryPrefix: true,
});

const defaultSelectedIdx = fid
  ? data.features.findIndex((el) => el.properties.fid.toString() === fid)
  : data.features.findIndex(
      (el) => el.properties.visible_name === "Академический"
    );

function App() {
  const [selectedIdx, setSelectedIdx] = useState(
    isMobile ? "" : defaultSelectedIdx
  );
  const [selected, setSelected] = useState(
    isMobile ? null : data.features[defaultSelectedIdx]
  );
  const [filter, setFilter] = useState("crime");
  const [year, setYear] = useState("2020");
  const [map, setMap] = useState(null);

  // const [mobileOpen, setMobileOpen] = useState(false);
  const featureClick = (feature, layer) => {
    const idx = data.features
      .map((el) => el.properties.visible_name)
      .indexOf(feature.properties.visible_name);
    setSelectedIdx(idx);
    setSelected(feature);
    layer.bringToFront();
    layer.setStyle({ color: "#fff", weight: 2 });
    layer.off("mouseover");
  };

  const handleSelectChange = (idx) => {
    setSelectedIdx(idx);
    setSelected(data.features[idx]);
  };

  const setHighlight = (feature, layer) => {
    layer.bringToFront();
    layer.setStyle({ color: "#fff", weight: 2 });
  };

  const unsetHighlight = (feature, layer) => {
    if (!isSelected(feature)) {
      layer.bringToBack();
      layer.setStyle({ color: "#000", weight: 1 });
    }
  };

  const getTooltip = (f) =>
    `${f.properties.visible_name} — ${f.properties[filter + "_" + year]}`;
  const chartData = ["16", "17", "18", "19", "20"].map((y) => {
    return {
      year: y,
      sum: selected
        ? selected.properties[filter + "_20" + y]
        : yearsData[filter + "_20" + y],
    };
  });
  const isSelected = (feature) => {
    return (
      feature.properties.visible_name === selected?.properties.visible_name
    );
  };

  const vals = data.features.map(
    (el) => parseInt(el.properties[filter + "_" + year]) || 0
  );
  const maxValue = Math.max(...vals);
  const mainValue = parseInt(selected?.properties[filter + "_" + year]) || 0;
  const shareLink = `https://www.proekt.media/guide/statistika-prestupnosti-v-rossii/?id=${
    selected?.properties.fid || ""
  }&%23moscow_guide`;

  return (
    <div className="App">
      <div className="filter_pane">
        {Object.keys(categories).map((k) => {
          if (filter === k) {
            return (
              <div
                className="filter_pane__item filter_pane__item--active"
                style={k === "cameras" ? { marginTop: 7 } : {}}
                key={k}
              >
                {categories[k].name}
              </div>
            );
          }
          return (
            <div
              className="filter_pane__item"
              style={k === "cameras" ? { marginTop: 7 } : {}}
              onClick={() => setFilter(k)}
              key={k}
            >
              {categories[k].name}
            </div>
          );
        })}
        <div className="filter_pane__years">
          {years.map((el) => {
            if (year === el) {
              return (
                <div
                  className="filter_pane__year filter_pane__year--active"
                  key={el}
                >
                  {el}
                </div>
              );
            }
            return (
              <div
                className="filter_pane__year"
                onClick={() => setYear(el)}
                key={el}
              >
                {el}
              </div>
            );
          })}
        </div>
      </div>
      <div
        className={`info_pane ${selected ? "mobile--open" : "mobile--closed"}`}
      >
        {selected && (
          <div
            className="close"
            onClick={() => {
              setSelected(null);
              setSelectedIdx("");
            }}
          >
            Назад к карте
          </div>
        )}
        {selected && (
          <div className="info_pane__districts">
            <select
              name="district"
              id=""
              className="info_pane__select"
              value={selectedIdx}
              onChange={(e) => handleSelectChange(e.target.value)}
            >
              <option value=""></option>
              {data.features.map((el, idx) => (
                <option value={idx} key={idx}>
                  {el.properties.visible_name}
                </option>
              ))}
            </select>
            <div className="info_pane__dropdown_list">
              {selected?.properties.dropdown_list}
            </div>
          </div>
        )}

        {!selected && (
          <>
            <div className="filter_pane__categories--mobile">
              <select
                name=""
                id=""
                value={filter}
                onChange={(ev) => setFilter(ev.target.value)}
              >
                {Object.keys(categories).map((k) => {
                  return (
                    <option value={k} key={k}>
                      {categories[k].name}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="filter_pane__years--mobile">
              {years.map((el) => {
                if (year === el) {
                  return (
                    <div
                      className="filter_pane__year filter_pane__year--active"
                      key={el}
                    >
                      {el}
                    </div>
                  );
                }
                return (
                  <div
                    className="filter_pane__year"
                    onClick={() => setYear(el)}
                    key={el}
                  >
                    {el}
                  </div>
                );
              })}
            </div>
          </>
        )}
        {selected && (
          <>
            <table className="info_pane__scale">
              <tbody>
                <tr>
                  <td
                    colSpan="5"
                    style={{
                      backgroundPositionX: `${(mainValue / maxValue) * 100}%`,
                    }}
                    className="info_pane__scale_mark"
                  ></td>
                </tr>
                <tr>
                  {colors.map((el) => (
                    <td style={{ backgroundColor: el }}></td>
                  ))}
                </tr>
              </tbody>
            </table>
            <div className="info_pane__header">На 100 тыс. жителей</div>
            <table className="info_pane__table">
              <tbody>
                {Object.keys(categories).map((k) => (
                  <tr key={k}>
                    <td
                      className="info_pane__table__key"
                      style={k === "cameras" ? { paddingTop: 10 } : {}}
                    >
                      {categories[k].name}
                    </td>
                    <td
                      className="info_pane__table__data"
                      style={k === "cameras" ? { paddingTop: 10 } : {}}
                    >
                      {selected?.properties[k + "_" + year]}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {selected?.properties["location_" + year] !== "Нет данных" && (
              <>
                <div className="info_pane__header">Опасные места</div>
                <div className="info_pane__location">
                  {selected?.properties["location_" + year]}
                </div>
              </>
            )}
            {selected && (
              <>
                <div className="info_pane__header">
                  Изменение по годам ({categories[filter].name_short})
                </div>
                <Chart
                  data={chartData}
                  dataKey={"sum"}
                  max={maxValue}
                  key={selected.visible_name}
                />
              </>
            )}
            <div className="social">
              <span>Поделиться:</span>
              <a
                target="_blank"
                rel="noreferrer"
                href={"https://www.facebook.com/sharer.php?u=" + shareLink}
              >
                <img src="/social/s1.svg" alt="fb" />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href={"http://vk.com/share.php?url=" + shareLink}
              >
                <img src="/social/s2.svg" alt="vk" />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href={"tg://msg_url?url=" + shareLink}
              >
                <img src="/social/s3.svg" alt="tg" />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://twitter.com/share?url=${shareLink}&text=${""}&via=wwwproektmedia`}
              >
                <img src="/social/s4.svg" alt="tw" />
              </a>
            </div>
          </>
        )}
      </div>
      <MapContainer
        zoomControl={false}
        center={[55.7558, 37.6173]}
        zoom={10}
        className="map"
        whenCreated={(map) => {
          map.eachLayer((layer) => {
            if (layer.feature && !isSelected(layer.feature)) {
              layer.bringToBack();
            }
          });
        }}
        key={`${filter}-${year}-${selectedIdx}`}
      >
        <ZoomControl position="bottomleft" />
        <GeoJSON
          data={data}
          key={`${filter}-${year}`}
          pathOptions={(el) => {
            const val = el.properties[filter + "_" + year];
            return {
              noClip: true,
              fillColor:
                val > 0
                  ? colors[Math.ceil(((val / maxValue) * 100) / 20) - 1]
                  : val === "Не было"
                  ? "#fff"
                  : "#838383",
              color: isSelected(el) ? "#fff" : "#000",
              weight: isSelected(el) ? 2 : 1,
              fillOpacity: 1,
            };
          }}
          onEachFeature={(feature, layer) => {
            isSelected(feature) && setHighlight(feature, layer);
            layer.bindTooltip(getTooltip(feature), { className: "tooltip" });
            layer.on("click", () => featureClick(feature, layer));
            layer.on("mouseover", () => {
              setHighlight(feature, layer);
            });
            layer.on("mouseout", () => {
              unsetHighlight(feature, layer);
            });
          }}
        />
      </MapContainer>
      <a
        href="https://www.proekt.media/guide/statistika-prestupnosti-v-rossii/"
        className="logo"
      >
        <img src={logo} alt="" />
      </a>
    </div>
  );
}

export default App;
